'use client';

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import { AlertBannerActionArea, AlertBannerContainer, AlertBannerContent, AlertBannerDismissButton, AlertBannerIconContainer, AlertBannerMessage, AlertBannerMessageText, AlertBannerTextButton } from './elements';
import { InternalProvider } from '../../util';
import { Icon } from '../Icon';
export const AlertBanner = /*#__PURE__*/React.forwardRef(({
  alertBannerType = 'default',
  isOpen,
  onCloseClick,
  iconSrc,
  hideDismissButton,
  containerClassName = '',
  dismissButtonClassName = '',
  iconContainerClassName = '',
  button,
  children,
  ...divProps
}, fRef) => {
  if (!children || typeof children === 'string') {
    children = /*#__PURE__*/React.createElement(AlertBannerMessageText, {
      "data-testid": "alert-banner-message-text"
    }, children);
  }
  return /*#__PURE__*/React.createElement(InternalProvider, null, /*#__PURE__*/React.createElement(AlertBannerContainer, _extends({
    "data-aui": "alert-banner",
    alertBannerType: alertBannerType,
    className: containerClassName,
    isOpen: isOpen,
    ref: fRef
  }, divProps), /*#__PURE__*/React.createElement(AlertBannerContent, null, iconSrc && /*#__PURE__*/React.createElement(AlertBannerIconContainer, {
    className: iconContainerClassName,
    "data-testid": "alert-banner-icon"
  }, /*#__PURE__*/React.createElement(Icon, {
    src: iconSrc,
    fill: "currentColor",
    size: "large"
  })), /*#__PURE__*/React.createElement(AlertBannerMessage, {
    "data-testid": "alert-banner-message"
  }, children), !hideDismissButton && /*#__PURE__*/React.createElement(AlertBannerDismissButton, {
    "aria-label": "Dismiss alert banner",
    "data-testid": "alert-banner-dismiss-button",
    iconSide: "left",
    iconSrc: "close-x",
    size: "medium",
    className: dismissButtonClassName,
    onClick: onCloseClick
  })), button && /*#__PURE__*/React.createElement(AlertBannerActionArea, null, /*#__PURE__*/React.createElement(AlertBannerTextButton, {
    "aria-label": button.ariaLabel,
    variant: "text",
    onClick: button.onClick,
    role: button.buttonRole
  }, button.text))));
});